import { render, staticRenderFns } from "./ButtonSolid.vue?vue&type=template&id=91e61470&scoped=true&"
import script from "./ButtonSolid.vue?vue&type=script&lang=ts&"
export * from "./ButtonSolid.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonSolid.vue?vue&type=style&index=0&id=91e61470&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91e61470",
  null
  
)

export default component.exports